module.exports = __webpack_public_path__ + "static/media/toalett.a89eafe7.m4a";